import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function CheckoutHeader() {
  const navigate = useNavigate();
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200" data-id="element-2161" data-mp="1kjoqp8qt1qsu">
      <div className="container mx-auto px-4" data-id="element-2162" data-mp="1khc0y9et2c58">
        <div className="relative flex items-center h-16" data-id="element-2163" data-mp="1fjk89d6c6lzz">
          {/* Back Button - Left Aligned */}
          <button onClick={() => navigate(-1)} className="flex items-center text-gray-700 hover:text-[#1E2B55] transition-colors z-10" data-id="element-2164" data-mp="1tjbkp9h7fubv">
            <ArrowLeftIcon className="w-5 h-5 mr-1" data-id="element-2165" data-mp="23apnbq4gda98" />
            <span className="text-sm font-medium" data-id="element-2166" data-mp="239ehzlvczug0">Back</span>
          </button>

          {/* Logo - Centered */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-2167" data-mp="1ydfpbm2zzq9s">
            <a href="/" className="pointer-events-auto" data-id="element-2168" data-mp="2d5zqih6l7nol">
              <img src="https://cdn.magicpatterns.com/uploads/enT9iVMZr5bUJi1w413sX2/Layer_1_(1).png" alt="Dawaak" className="h-10 w-auto" data-id="element-2169" data-mp="28akelus541ut" />
            </a>
          </div>
        </div>
      </div>
    </header>;
}